webpackJsonp([6],{

/***/ 713:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__ = __webpack_require__(778);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a21e6d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__ = __webpack_require__(798);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a21e6d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_phone_number_input__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_phone_number_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_phone_number_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_helper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_phone_number_input_dist_vue_phone_number_input_css__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_phone_number_input_dist_vue_phone_number_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_phone_number_input_dist_vue_phone_number_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import { titleize } from '@/helper/index.js'

var profileFields = {
  name: null,
  surname: null,
  phone: null,
  email: null,
  has_children: true,
  children_birthdate: [{
    value: ''
  }]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProfile',
  created: function created() {
    this.loading = true;
    this.callProfileAction();
  },
  props: {
    source: Object
  },
  data: function data() {
    var initialized = {
      modalBirthdate: false,
      activePicker: null,
      valid: true,
      loading: true,
      isSuccess: false,
      snackbar: false,
      text: 'Datos guardados con éxito',
      children_placeholder_texts: ['primer hijo', 'segundo hijo', 'tercer hijo', 'cuarto hijo', 'quinto hijo', 'sexto hijo', 'séptimo hijo', 'octavo hijo'],
      vertical: false,
      rules: [function (value) {
        return value && value.length >= 3 || 'Min 3 characters';
      }],
      emailRules: [function (v) {
        return (/.+@.+\..+/.test(v) || 'E-mail debe ser válido'
        );
      }],
      rulesRequired: [function (v) {
        return !!v || 'Required';
      }]
    };
    for (var fieldKey in profileFields) {
      initialized[fieldKey] = profileFields[fieldKey];
    }
    return initialized;
  },
  components: { VuePhoneNumberInput: __WEBPACK_IMPORTED_MODULE_2_vue_phone_number_input___default.a },
  watch: {
    modalBirthdate: function modalBirthdate(val) {
      var _this = this;

      val && setTimeout(function () {
        return _this.activePicker = 'YEAR';
      });
    },

    children_birthdate: {
      handler: function handler(item) {
        item.activePicker = 'YEAR';
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getProfileData']), {
    childrenBirthdateLength: function childrenBirthdateLength() {
      return this.children_birthdate.length <= 7;
    },
    styles: function styles() {
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* convertEmToPixels */])(16);
      return {
        'font-size': result + 'px',
        'line-height': result + 2 + 'px'
      };
    },
    stylesAddOtheChild: function stylesAddOtheChild() {
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__helper_helper__["b" /* convertEmToPixels */])(14);
      return {
        'font-size': result + 'px',
        'line-height': result + 2 + 'px'
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    profileAction: 'GET_PROFILE',
    saveBoarding: 'ONBOARDING',
    addChangeToQueue: 'ADD_TO_QUEUE'
  }), {
    callProfileAction: function callProfileAction() {
      var _this2 = this;

      this.profileAction().then(function (profile) {
        profile.children_birthdate = __WEBPACK_IMPORTED_MODULE_5_vue_underscore__["a" /* _ */].isEmpty(profile.children_birthdate) ? [''] : profile.children_birthdate;
        for (var field in profile) {
          _this2[field] = __WEBPACK_IMPORTED_MODULE_5_vue_underscore__["a" /* _ */].isArray(profileFields[field]) ? (profile[field] || []).map(function (val) {
            return { value: val };
          }) : profile[field];
        }
        _this2.loading = false;
      });
    },
    validate: function validate() {
      var _this3 = this;

      var dataToSend = {};
      for (var fieldKey in profileFields) {
        dataToSend[fieldKey] = __WEBPACK_IMPORTED_MODULE_5_vue_underscore__["a" /* _ */].isArray(this[fieldKey]) ? this[fieldKey].map(function (_ref) {
          var value = _ref.value;
          return value;
        }) : this[fieldKey];
      }
      this.$refs.formProfile.validate() && this.saveBoarding(dataToSend).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* RegisterEvent */])('chi_save_profile', {
          target: _this3.$store.getters.firebaseUUID(),
          target_type: 'user_id'
        });
        _this3.isSuccess = true;
        _this3.snackbar = true;
        _this3.addChangeToQueue({
          currentScreen: 'users',
          fieldsName: ['name', 'surname', 'email', 'phone', 'has_children', 'children_birthdate', 'disabled_fields']
        });
      });
    },
    add: function add() {
      var value = {
        value: '',
        show: true
      };
      this.children_birthdate.push(value);
    },
    remove: function remove(index) {
      this.children_birthdate.splice(index, 1);
    },
    getDisabledInputs: function getDisabledInputs(name) {
      return __WEBPACK_IMPORTED_MODULE_5_vue_underscore__["a" /* _ */].indexOf(this.getProfileData.disabled_fields, name) > 0;
    }
  })
});

/***/ }),

/***/ 798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:" p-30 onboarding-content",attrs:{"width":"100%","height":"100%"}},[_c('v-form',{ref:"formProfile",staticClass:"form-profile",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"form-inputs-wrapper"},[_c('v-text-field',{staticClass:"capitalize",style:(_vm.styles),attrs:{"dense":"","label":"Nombre de pila","rules":_vm.rules,"required":"","disabled":_vm.getDisabledInputs('name')},on:{"change":function($event){_vm.name = $event}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{style:(_vm.styles),attrs:{"dense":"","label":"Email","rules":_vm.emailRules,"disabled":_vm.getDisabledInputs('email')},on:{"change":function($event){_vm.email = $event}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('vue-phone-number-input',{attrs:{"translations":{
          countrySelectorLabel: null,
          countrySelectorError: 'Escoge un país',
          phoneNumberLabel: 'Número de teléfono',
          example: 'Ej.'
        },"border-radius":0,"default-country-code":'ES',"preferred-countries":['ES'],"show-code-on-list":"","disabled":_vm.getDisabledInputs('phone')},on:{"change":function($event){_vm.phone = $event}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('div',{staticClass:"how-many-children",style:(_vm.styles)},[_vm._v("\n        ¿Tienes hijos o los tendrás pronto?\n      ")]),_vm._v(" "),_c('v-switch',{style:(_vm.styles),attrs:{"inset":"","label":_vm.has_children ? 'Sí' : 'No',"disabled":_vm.getDisabledInputs('has_children')},on:{"change":function($event){_vm.has_children = $event}},model:{value:(_vm.has_children),callback:function ($$v) {_vm.has_children=$$v},expression:"has_children"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.has_children),expression:"has_children"}]},[_vm._l((_vm.children_birthdate),function(itemField,index){return _c('v-dialog',{key:("childrenBirthdate" + index),ref:"children_birthdate",refInFor:true,attrs:{"return-value":itemField.value,"persistent":"","width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(itemField, "value", $event)},"update:return-value":function($event){return _vm.$set(itemField, "value", $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
        var attrs = ref.attrs;
return [_c('p',{directives:[{name:"show",rawName:"v-show",value:(index === 0),expression:"index === 0"}],style:(_vm.styles)},[_vm._v("\n              Indica la fecha de nacimiento de tus hijos\n            ")]),_vm._v(" "),_c('v-text-field',_vm._g(_vm._b({attrs:{"prepend-icon":"mdi-calendar-month-outline","readonly":"","rules":_vm.rulesRequired,"label":("Fecha de nacimiento de tu " + (_vm.children_placeholder_texts[index])),"disabled":_vm.getDisabledInputs('children_birthdate')},on:{"change":function($event){itemField.value = $event}},model:{value:(itemField.value),callback:function ($$v) {_vm.$set(itemField, "value", $$v)},expression:"itemField.value"}},'v-text-field',attrs,false),on),[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(index > 0),expression:"index > 0"}],attrs:{"slot":"append","color":"red"},on:{"click":function($event){return _vm.remove(index)}},slot:"append"},[_vm._v("mdi-minus")])],1)]}}],null,true),model:{value:(itemField.show),callback:function ($$v) {_vm.$set(itemField, "show", $$v)},expression:"itemField.show"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"active-picker":itemField.activePicker,"scrollable":""},on:{"update:activePicker":function($event){return _vm.$set(itemField, "activePicker", $event)},"update:active-picker":function($event){return _vm.$set(itemField, "activePicker", $event)}},model:{value:(itemField.value),callback:function ($$v) {_vm.$set(itemField, "value", $$v)},expression:"itemField.value"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{style:(_vm.styles),attrs:{"text":"","color":"primary"},on:{"click":function($event){itemField.show = false}}},[_vm._v("\n              Cancel\n            ")]),_vm._v(" "),_c('v-btn',{style:(_vm.styles),attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$refs.children_birthdate[index].save(itemField.value)}}},[_vm._v("\n              OK\n            ")])],1)],1)}),_vm._v(" "),(_vm.childrenBirthdateLength)?_c('div',{staticClass:"d-flex align-center mb-10",on:{"click":function($event){return _vm.add()}}},[_c('v-btn',{attrs:{"text":"","icon":""}},[_c('v-icon',{attrs:{"size":"16","color":"primary"}},[_vm._v("\n              mdi-plus\n            ")])],1),_vm._v(" "),_c('span',{staticStyle:{"color":"#1976d2","font-size":"14px"},style:(_vm.stylesAddOtheChild)},[_vm._v("Añadir otro hijo")])],1):_vm._e()],2)],1),_vm._v(" "),_c('div',{staticClass:"form-buttons-wrapper"},[_c('v-btn',{staticClass:"rounded-lg",attrs:{"disabled":!_vm.valid,"large":"","block":"","color":"primary"},on:{"click":_vm.validate}},[_vm._v("\n        Guardar\n      ")]),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","vertical":_vm.vertical,"color":"success","timeout":"5000"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
        var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"white","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n            Close\n          ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        "+_vm._s(_vm.text)+"\n        ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.cd9d9922c4eca7b1318f.js